var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_53)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_100_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16 -6C-16 -12.6274 -10.6274 -18 -4 -18H1380C1386.63 -18 1392 -12.6274 1392 -6V46C1392 52.6274 1386.63 58 1380 58H-3.99997C-10.6274 58 -16 52.6274 -16 46V-6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 20C26.5 20.5531 26.0531 21 25.5 21H14.5C13.9469 21 13.5 20.5531 13.5 20C13.5 19.4469 13.9469 19 14.5 19H25.5C26.0531 19 26.5 19.4469 26.5 20Z",
    fill: "#EF4444"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_100_53",
    x: -18,
    y: -19,
    width: 1412,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1440,
    fill: "none",
    transform: "translate(-32 -164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUse);
export default __webpack_public_path__ + "static/media/use.740c5bca6ca57f4deafe0eef413388e6.svg";
export { ForwardRef as ReactComponent };